module.exports = __webpack_public_path__ + "img/ic_done_green.bfb18fa7.svg";